import type { Control, FieldPath } from "react-hook-form";
import { z } from "zod";
import TextField from "@mui/material/TextField";
import { Controller } from "react-hook-form";
import { createChangePasswordSchema } from "@/schema";

const ChangePasswordSchema = createChangePasswordSchema((key: string) => key);

interface ChangePasswordFormFieldViewProps {
  name: FieldPath<z.infer<typeof ChangePasswordSchema>>;
  label: string;
  placeholder: string;
  inputType?: string;
  formControl: Control<z.infer<typeof ChangePasswordSchema>>;
}

const ChangePasswordFormFieldView: React.FC<
  ChangePasswordFormFieldViewProps
> = ({ name, label, placeholder, inputType, formControl }) => {
  return (
    <Controller
      name={name}
      control={formControl}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          type={inputType || "password"}
          label={label}
              placeholder={placeholder}
          fullWidth
          variant="outlined"
          margin="normal"
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          InputLabelProps={{ shrink: true }}
        />
      )}
    />
  );
};

export default ChangePasswordFormFieldView;
